import React from "react";
import { FaBold } from "react-icons/fa";
import Header from "../header";
import Navvbar from "./../Navvbar";

const Keyboard = () => {
  return (
    <div>
      <Header />
      <Navvbar />
      <br />
      <br />
      <div
        style={{
          width: "95%",
          margin: "0 auto",
          borderBottom: "2px solid #004aad",
          padding: "10px",
          backgroundColor: "#f0f0f0",
          color: "black",
          fontFamily: FaBold,
        }}
      >
        <h2>Keyboard Shortcuts</h2>
      </div>
      <div
        style={{
          padding: "20px",
          backgroundColor: "#f0f0f0",
          width: "95%",
          margin: "0 auto",
        }}
      >
        <h2>General Hotkeys</h2>
        <ul>
          <li>
            <h5>
              <b>Hotkey Shortcuts (Ctrl+Alt+H):</b>
            </h5>{" "}
            Display This Keyboard Shortcuts Window
          </li>
          <li>
            <h5>
              <b>Search (Ctrl+Alt+S):</b>
            </h5>{" "}
            Bring Search Box Into Focus
          </li>
          <li>
            <h5>
              <b>Account Selection (Ctl+Alt+F):</b>
            </h5>{" "}
            Choose a federated account{" "}
          </li>

          <li>
            <h5>
              <b>New Case (Ctl+Alt+N):</b>
            </h5>{" "}
            Launches New Case Entry Window{" "}
          </li>
          <li>
            <h5>
              <b>Posting Entries (Ctl+Alt+P):</b>
            </h5>{" "}
            Launches Posting Entries Window{" "}
          </li>
          <li>
            <h5>
              <b>Accounts (Ctl+Alt+A):</b>
            </h5>{" "}
            Launches Accounts Window{" "}
          </li>
          {/* Add more list items as needed */}
        </ul>
      </div>
    </div>
  );
};

export default Keyboard;
